import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import Logo from "./Logo";
import UserMenu from "./UserMenu";

const TopBar = ({ onMenuClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (!isMobile) {
    return null; // Don't show top bar on desktop
  }

  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={0}
      sx={{
        width: { md: `calc(100% - 250px)` },
        ml: { md: "250px" },
        zIndex: theme.zIndex.drawer + 1,
        top: 0,
        left: { md: "250px" },
        right: 0,
      }}
    >
      <Toolbar sx={{ py: 0 }}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onMenuClick}
          sx={{ mr: 1.5, color: "text.primary" }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" }}>
          <Logo compact sx={{ color: "text.primary" }} />
        </Box>
        <UserMenu />
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
